package com.ragnorak.clanybackoffice

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
// import com.clany.backoffice.di.initKoin

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    // initKoin() // Removed
    ComposeViewport("composeApp") {
        App()
    }
}